const tableTitleUser = {
  title: 'Usuarios',
  placeholder: 'Buscar'
};

export default tableTitleUser;
